module.exports = __webpack_public_path__ + "img/ico_zhongjidajiang.cd1c9192.png";